import { styled } from 'stitches.config'

export const RawDietRoot = styled('div', {
  position: 'relative',
  backgroundColor: '$tertiary-200',
  py: '$8',
  px: '$4',
  marginTop: '$7',
  borderBottom: '9px solid transparent',
  borderTop: 0,

  '@bp2': {
    borderTopLeftRadius: '75px',
    borderTopRightRadius: '75px',
  },

  '@bp3': {
    marginTop: 0,
  },
})

export const TextContainer = styled('div', {
  maxWidth: '60%',
  margin: 'auto',
})
